import React, { useState } from 'react';



const faqs = [
    {
        q: 'What makes Bliv Design Studio a leading luxury interior decorator?',
        a: 'Bliv Design Studio combines award-winning design talent with over a decade of experience. We offer end-to-end solutions from concept to completion, serving 1000+ happy clients across Hyderabad, Nizamabad, Bangalore, Vizag, Puttaparthi, Anantapur, Vijayawada, and Rajahmundry with premium materials and precision craftsmanship.',
    },
    {
        q: 'Are your interior designer services budget-friendly?',
        a: 'Absolutely! We offer a range of packages to suit different budgets without compromising on quality. Our transparent pricing with no hidden costs ensures you get the best value for your investment.',
    },
    {
        q: 'Can I get affordable interior decor services without sacrificing quality?',
        a: 'Yes! At Bliv Design Studio, we believe luxury design should be accessible. We use cost-efficient materials like HDHMR and laminate finishes that look premium without breaking your budget.',
    },
    {
        q: 'What types of residential interior design services do you offer?',
        a: 'We offer complete residential interior design services including modular kitchens, wardrobes, TV units, false ceilings, bathroom design, pooja units, kids rooms, foyer design, wall paneling, and more.',
    },
    {
        q: 'Do you provide specialized interior designs for commercial spaces?',
        a: 'Yes, we design commercial interiors for offices, retail stores, clinics, and hospitality spaces. Our team has expertise in creating functional yet aesthetically pleasing commercial environments.',
    },
    {
        q: 'How does Bliv Design Studio handle healthcare interior design projects?',
        a: 'Our healthcare design team specializes in infection-control compliant materials, efficient layouts, calming color palettes, and durable finishes suitable for clinics and hospitals.',
    },
    {
        q: 'Can Bliv Design Studio design a modular kitchen for my home?',
        a: 'Absolutely! Modular kitchens are one of our specialties. We design custom kitchens using MDF, plywood, HDHMR, and acrylic finishes with smart storage solutions and ergonomic layouts.',
    },
    {
        q: 'What is the process to start a project with Bliv Design Studio?',
        a: 'It\'s simple! Book a free consultation and our designers will visit your space, understand your requirements, create a 3D design plan, and begin execution upon your approval. Reach us at +91 9959365158.',
    },
];

export default function NewsAndFAQ() {
    const [openFaq, setOpenFaq] = useState(null);

    return (
        <>


            {/* FAQ */}
            <section className="section-pad bg-[#F8F9FA]" id="faq">
                <div className="max-w-4xl mx-auto px-4">
                    <div className="text-center mb-12">
                        <p className="text-[#2E63E8] font-semibold uppercase tracking-widest text-sm mb-2">Got Questions?</p>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
                        <div className="w-20 h-1 bg-[#2E63E8] mx-auto rounded-full"></div>
                    </div>
                    <div className="space-y-3">
                        {faqs.map((faq, i) => (
                            <div
                                key={i}
                                className={`bg-white rounded-xl border transition-all duration-300
                  ${openFaq === i ? 'border-[#2E63E8] shadow-md' : 'border-gray-200 shadow-sm'}`}
                            >
                                <button
                                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                                    className="w-full flex items-center justify-between px-6 py-4 text-left"
                                >
                                    <span className={`font-semibold text-sm md:text-base pr-4 ${openFaq === i ? 'text-[#2E63E8]' : 'text-gray-800'}`}>
                                        {faq.q}
                                    </span>
                                    <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300
                    ${openFaq === i ? 'bg-[#2E63E8] text-white rotate-180' : 'bg-gray-100 text-gray-600'}`}>
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </span>
                                </button>
                                <div className={`accordion-content ${openFaq === i ? 'open' : ''}`}>
                                    <p className="px-6 pb-5 text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
